import { Box, Button, IconButton } from "@mui/material";
import TableRow from "@mui/material/TableRow";
import styled from "@emotion/styled";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { Helmet } from "react-helmet";
import { useModal } from "../../../components/modal";
import { DeleteModal } from "../../../components/appbar/modal";
import Navbar from "../../../components/navbar";
import { smallButton } from "../../../components/Button";
import StickyTable from "../../../components/table";
import { Cell } from "../../../components/table/styles";
import MainFrame from "../../../components/mainFrame";
import Addmodal from "./modal";
import OrgansMenuItems from "../components/menuitems";
import {
  useGetCoursesQuery,
  useRemoveCourseMutation,
} from "../../../app/services/organ.api";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { PaginationQuery } from "../../../types/query";

const Container = styled(Box)({
  padding: "1rem",
  width: "100%",
  height: "100%",
  minHeight: "90vh",
  maxHeight: "90vh",
});
function OrganCourses() {
  const { setShow, setContent } = useModal();
  const [query, setQuery] = useState<PaginationQuery>({
    page: 0,
    size: 10,
  });
  const params = useParams() as { organ: string };
  const { data, isLoading, isFetching } = useGetCoursesQuery({
    organId: params.organ,
    query,
  });

  const [removeCourse] = useRemoveCourseMutation();

  function handleOpenModal(type: string, id?: string) {
    if (type === "add") {
      setContent({
        title: " افزودن دوره",
        body: <Addmodal organId={params.organ} />,
      });
    }
    if (type === "delete" && id) {
      setContent({
        title: "حذف دوره",
        body: (
          <DeleteModal
            handleDelete={() => {
              removeCourse({
                accessId: id,
                organId: params.organ,
              })
                .unwrap()
                .then(() => {
                  setShow(false);
                })
                .catch((err) => {});
            }}
          />
        ),
      });
    }
    setShow(true);
  }
  return (
    <Container bgcolor="primary.light">
      <Helmet>
        <title> دوره های سازمان | پنل ادمین yaadin</title>
      </Helmet>
      <Navbar title=" دوره های سازمان">
        <Button
          onClick={() => handleOpenModal("add")}
          sx={[
            smallButton,
            {
              color: "divider",
              borderColor: "divider",
              borderStyle: "solid",
              borderWidth: "1px",
            },
          ]}
        >
          <AddIcon />
          افزودن دوره
        </Button>
      </Navbar>
      <StickyTable
        headers={[{ name: "عنوان" }, { name: "اسلاگ" }, { name: "نوع" }]}
        operations={true}
        length={data?.length ?? 0}
        isLoading={isLoading || isFetching}
        onPageQueryChange={(q) => setQuery((prev) => ({ ...prev, ...q }))}
      >
        {data?.courses?.ids?.map((id, indx) => {
          const course = data?.courses?.entities[id];
          return (
            <TableRow
              hover
              role="checkbox"
              tabIndex={-1}
              key={id}
              sx={{
                "&.MuiTableRow-root": {
                  cursor: "pointer",
                },
              }}
            >
              <Cell
                sx={{
                  "&.MuiTableCell-root": {
                    color: "divider",
                    fontSize: ".8rem",
                  },
                }}
              >
                {indx + 1}
              </Cell>
              <Cell>{course.title}</Cell>
              <Cell>{course.slug}</Cell>
              <Cell
                title={
                  course.organPrivate
                    ? "فقط اعضای سازمان می‌بینند"
                    : "دوره عمومی است؛ اعضای سازمان بدون خرید دسترسی دارند"
                }
              >
                {course.organPrivate ? "خصوصی سازمان" : "عمومی (خریداری‌شده)"}
              </Cell>
              <Cell
                sx={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={(e) => {
                    e.stopPropagation();
                    handleOpenModal("delete", id);
                  }}
                >
                  <DeleteIcon sx={{ color: "divider" }} />
                </IconButton>
              </Cell>
            </TableRow>
          );
        })}
      </StickyTable>
    </Container>
  );
}

export default MainFrame(OrganCourses, <OrgansMenuItems />);
